export default __webpack_public_path__ + "static/icon-2-6-efa8a59f76744eeb3285531455df4124.png";